<div class="header-box" [ngClass]="id ? 'with-info-box' : ''">
  <div class="d-flex align-items-center heading-box">
    <ng-icon
      [name]="
        mode == 'view'
          ? 'heroUserGroup'
          : mode == 'edit'
          ? 'heroUserGroup'
          : 'heroUserPlus'
      "
    ></ng-icon>
    <div>
      <h2 *ngIf="mode">
        <small>{{ mode + " Role" | titlecase }}</small>
      </h2>
      <h2 *ngIf="formLoading; else loaded">
        <ngx-skeleton-loader
          [theme]="{ height: '20px', width: '200px' }"
        ></ngx-skeleton-loader>
      </h2>
      <ng-template #loaded>
        <h2>{{ id ? (role?.roleName | titlecase) : "Add Role" }}</h2>
      </ng-template>
    </div>
  </div>
  <div class="d-flex justify-content-end align-items-center col-md-6 p-0">
    <button
      color="accent"
      mat-raised-button
      *ngIf="
        userService.permissionsValue['_USER_MANAGEMENT_EDIT_'] && mode == 'view'
      "
      [routerLink]="['/app/role', 'edit', id]"
    >
      Edit Role
    </button>
  </div>
</div>
<div class="inner-box" >
  <mat-card [ngStyle]="{ padding: '10px' }">
    <mat-card-content class="form-head" [ngStyle]="{ margin: '12px' }">
      <nav [class.hidden-navbar]="hideNavbar">
        <div class="nav nav-tabs nav-pills" id="nav-tab" role="tablist">
          <button
            class="nav-item nav-link bgtab-white active mr-2"
            id="nav-role-tab"
            data-toggle="tab"
            (click)="tab('nav-role')"
            role="tab"
            aria-controls="nav-role"
            aria-selected="true"
          >
            Role
          </button>
          <button
            class="nav-item nav-link bgtab-white"
            id="nav-permission-tab"
            data-toggle="tab"
            (click)="tab('nav-permission')"
            role="tab"
            aria-controls="nav-permission"
            aria-selected="false"
            disabled
          >
            Permissions
          </button>
        </div>
      </nav>
      <div class="tab-content" id="nav-tabContent">
        <div
          class="tab-pane fade show active"
          id="nav-role"
          role="tabpanel"
          aria-labelledby="nav-role-tab"
        >
          <form class="needs-validation" novalidate #roleForm="ngForm">
            <h4>Add Role</h4>
            <div class="col-md-12 d-flex p-0">
              <div class="col-md-3" [hidden]="true">
                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Tenant ID</mat-label>
                    <input
                      matInput
                      type="text"
                      name="TenantID"
                      readonly
                      [(ngModel)]="usermanagementService.thisRole.tenantId"
                      class="form-control col-ht-35"
                      id="validationTooltip01"
                      value="System Generated"
                      required
                    />
                  </mat-form-field>
                </div>
              </div>

              <div class="col-md-3">
                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Role</mat-label>
                    <input
                      type="text"
                      matInput
                      class="form-control col-ht-35"
                      name="RoleName"
                      [(ngModel)]="usermanagementService.thisRole.name"
                      id="validationTooltip05"
                      placeholder="Add Role Name"
                      [disabled]="
                        !userService.permissionsValue[
                          '_USER_MANAGEMENT_EDIT_'
                        ] || mode == 'view'
                      "
                      required
                    />
                  </mat-form-field>
                </div>
              </div>
              <div class="col-md-3">
                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Description</mat-label>
                    <input
                      matInput
                      type="text"
                      class="form-control col-ht-35"
                      name="Description"
                      [(ngModel)]="usermanagementService.thisRole.description"
                      id="validationTooltip03"
                      placeholder="Add Description"
                      [disabled]="
                        !userService.permissionsValue[
                          '_USER_MANAGEMENT_EDIT_'
                        ] || mode == 'view'
                      "
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </form>
          <div
            class="col-md-12 d-flex p-0 justify-content-end"
            *ngIf="mode != 'view'"
          >
            <div class="pr-2">
              <button
                color="warn"
                class="outlined-btn"
                mat-raised-button
                (click)="resetForm(roleForm)"
                type="reset"
                [disabled]="isLoading"
              >
                Reset
              </button>
            </div>
            <button
              color="accent"
              mat-raised-button
              class="ml-3"
              type="button"
              class="btn btn-secondary button-oranged"
              (click)="next()"
              [disabled]="!roleForm.valid"
            >
              Next
            </button>
          </div>
        </div>

        <div
          class="tab-pane fade"
          id="nav-permission"
          role="tabpanel"
          aria-labelledby="nav-permission-tab"
        >
          <form #userModuleSubmodulePermissionForm="ngForm" >
              <div  class="col-md-12 d-flex p-0 mb-3">
                <div class="col-md-4">
                  <select
                    id="inputState"
                    class="form-control col-ht-35"
                    name="module"
                    [(ngModel)]="selectedModuleinUI"
                    required
                  >
                    <option selected [ngValue]="null">Select Module</option>
                    <option
                      *ngFor="
                        let module of usermanagementService
                          .modulesSubmodulesPermissionsMaster.moduleDTOs;
                        let i = index
                      "
                      [ngValue]="module.id"
                    >
                      {{ module.name }}
                    </option>
                  </select>
                </div>
              </div>

            <div class="tablepadd" [ngStyle]="{margin: '6px'}" *ngIf="selectedModuleinUI !== null">
              <div class="table-responsive">
                <table class="table table-striped table-bordered">
                  <thead class="headrow">
                    <tr>
                      <th class="p-tablecell" scope="col">Module</th>
                      <th
                        class="p-tablecell"
                        scope="col"
                        *ngFor="
                          let permission of usermanagementService.thisPermissionsMater
                        "
                      >
                        {{ permission.name }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container
                      *ngFor="
                        let module of usermanagementService
                          .modulesSubmodulesPermissionsMaster.moduleDTOs;
                        let i = index
                      "
                    >
                      <ng-container *ngIf="selectedModuleinUI == module.id">
                        <tr
                          *ngFor="
                            let submodule of module.subModuleDTOs;
                            let j = index
                          "
                        >
                          <td class="p-rowcell pl-4">{{ submodule.name }}</td>

                          <td
                            class="p-rowcell"
                            *ngFor="
                              let permission of usermanagementService.thisPermissionsMater
                            "
                          >
                            <input
                              [name]="
                                'permissionValue' +
                                module.id +
                                '-' +
                                submodule.id +
                                '-' +
                                permission.id
                              "
                              type="checkbox"
                              class="hw-checkbox"
                              [(ngModel)]="
                                module_submodule_permissions[
                                  module.id + '-' + submodule.id
                                ][permission.id]
                              "
                              (change)="
                                toggle(
                                  $event,
                                  permission.id,
                                  submodule.id,
                                  module.id,
                                  i
                                )
                              "
                              [disabled]="
                                module_submodule_permissions_disables[
                                  module.id + '-' + submodule.id
                                ][permission.id] == null
                                  ? true
                                  : module_submodule_permissions_disables[
                                      module.id + '-' + submodule.id
                                    ][permission.id]
                              "
                            />
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </form>
          <div class="col-md-12 d-flex p-0 justify-content-end" *ngIf="mode != 'view'">
            <div class="pr-2">
              <button
                color="warn"
                class="outlined-btn"
                mat-raised-button
                (click)="reset()"
                type="button"
                [disabled]="isLoading"
              >
                Reset
              </button>
            </div>
          
            <div class="pr-2">
              <button
                color="accent"
                mat-raised-button
                style="width: 145px white-space nowrap"
                type="button"
                *ngIf="mode != 'view' && userService.permissionsValue['_USER_MANAGEMENT_EDIT_']"
                [disabled]="!userModuleSubmodulePermissionForm.valid"
                (click)="createRole(true)"
                class="ml-2"
              >
                Save & Activate
              </button>
            </div>
          
              <button
                color="accent"
                mat-raised-button
                type="button"
                *ngIf="mode != 'view' && userService.permissionsValue['_USER_MANAGEMENT_EDIT_']"
                [disabled]="!userModuleSubmodulePermissionForm.valid"
                (click)="createRole(false)"
                class="btn btn-secondary button-oranged "
              >
                Save
              </button>
          </div>
          
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
<!-- <div class="container-fluid ml-4">
  <div class="row">
    <div class="col-lg-12"> -->
<!-- <div class="header-box" [ngClass]="id ? 'with-info-box' : ''">
        <div class="d-flex align-items-center heading-box">
          <ng-icon
            [name]="
              mode == 'view'
                ? 'heroUserGroup'
                : mode == 'edit'
                ? 'heroUserGroup'
                : 'heroUserPlus'
            "
          ></ng-icon>
          <div>
            <h2 *ngIf="mode">
              <small>{{ mode + " Role" | titlecase }}</small>
            </h2>
            <h2 *ngIf="formLoading; else loaded">
              <ngx-skeleton-loader
                [theme]="{ height: '20px', width: '200px' }"
              ></ngx-skeleton-loader>
            </h2>
            <ng-template #loaded>
              <h2>
                {{
                  id
                    ? (usermanagementService.thisRole.name | titlecase)
                    : "Add Role"
                }}
              </h2>
            </ng-template>
          </div>
        </div>
        <div class="d-flex justify-content-end align-items-center col-md-6 p-0">
          <button
            color="accent"
            mat-raised-button
            *ngIf="
              userService.permissionsValue['_USER_MANAGEMENT_EDIT_'] &&
              mode == 'view'
            "
            [routerLink]="['/app/role', 'edit', id]"
          >
            Edit Role
          </button>
        </div>
      </div>
      <div class="info-box" *ngIf="id">
        <div class="info-section">
          <h3><small>Tenant Id</small></h3>
          <h3 *ngIf="formLoading; else loadedId">
            <ngx-skeleton-loader
              [theme]="{ height: '15px', width: '150px' }"
            ></ngx-skeleton-loader>
          </h3>
          <ng-template #loadedId>
            <h3>{{ usermanagementService.thisRole.tenantId }}</h3>
          </ng-template>
        </div>
        <div class="info-section">
          <h3><small>Status</small></h3>
          <h3 *ngIf="formLoading; else loadedStatus">
            <ngx-skeleton-loader
              [theme]="{ height: '15px', width: '150px' }"
            ></ngx-skeleton-loader>
          </h3>
          <ng-template #loadedStatus>
            <h3>
              {{
                usermanagementService.thisRole.status == 0
                  ? "Inactive"
                  : "Active"
              }}
            </h3>
          </ng-template>
        </div>
        <div class="info-section" *ngIf="mode">
          <h3><small>Created By</small></h3>
          <h3 *ngIf="formLoading; else loadedName">
            <ngx-skeleton-loader
              [theme]="{ height: '15px', width: '150px' }"
            ></ngx-skeleton-loader>
          </h3>
          <ng-template #loadedName>
            <h3>{{ usermanagementService.thisRole.createdBy | titlecase }}</h3>
          </ng-template>
        </div>
      </div>
      <div class="inner-box">
        <mat-card>
          <mat-card-content class="form-head">
            <div *ngIf="formLoading; else show">
              <ngx-skeleton-loader
                [theme]="{ height: '60px', width: '20%' }"
              ></ngx-skeleton-loader>
              <div class="pt-3">
                <ngx-skeleton-loader
                  [theme]="{ height: '40px' }"
                ></ngx-skeleton-loader>
              </div>
              <div class="pt-3">
                <ngx-skeleton-loader
                  [theme]="{ height: '40px' }"
                ></ngx-skeleton-loader>
              </div>
              <div class="pt-3">
                <ngx-skeleton-loader
                  [theme]="{ height: '40px' }"
                ></ngx-skeleton-loader>
              </div>
              <div class="pt-5">
                <ngx-skeleton-loader
                  [theme]="{ height: '50px', width: '10%', float: 'right' }"
                ></ngx-skeleton-loader>
                <ngx-skeleton-loader
                  [theme]="{
                    height: '50px',
                    width: '5%',
                    opacity: '0',
                    float: 'right',
                    visibility: 'hidden'
                  }"
                ></ngx-skeleton-loader>
                <ngx-skeleton-loader
                  [theme]="{ height: '50px', width: '10%', float: 'right' }"
                ></ngx-skeleton-loader>
              </div>
            </div>
            <ng-template #show>
              <form #roleForm="ngForm">
                <h4>Add Role</h4>
                <div class="col-md-12 d-flex p-0">
                  <div class="col-md-3">
                    <div class="dense-2">
                      <mat-form-field appearance="outline">
                        <mat-label>Role Name</mat-label>
                        <input
                          type="text"
                          matInput
                          name="RoleName"
                          [(ngModel)]="usermanagementService.thisRole.name"
                          autocomplete="off"
                          required
                          [disabled]="
                            !userService.permissionsValue[
                              '_USER_MANAGEMENT_EDIT_'
                            ] || mode == 'view'
                          "
                        />
                        <mat-error
                          *ngIf="roleForm.controls['RoleName'].invalid"
                        >
                          Role Name is required
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="dense-2">
                      <mat-form-field appearance="outline">
                        <mat-label>Description</mat-label>
                        <input
                          type="text"
                          matInput
                          name="Description"
                          [(ngModel)]="
                            usermanagementService.thisRole.description
                          "
                          autocomplete="off"
                          [disabled]="
                            !userService.permissionsValue[
                              '_USER_MANAGEMENT_EDIT_'
                            ] || mode == 'view'
                          "
                        />
                        <mat-error
                          *ngIf="roleForm.controls['Description'].invalid"
                        >
                          Description is required
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <h4>Associate Permissions</h4>
                <div class="col-md-12 d-flex p-0">
                  <div class="col-md-4">
                    <div class="dense-2">
                      <mat-form-field appearance="outline">
                        <mat-label>Select Module</mat-label>
                        <mat-select [errorStateMatcher]="matcher" (selectionChange)="onModuleSelect($event)">
                          <mat-option *ngFor="let module of modules" [value]="module.id">{{ module.name }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 d-flex p-0" *ngIf="selectedModule">
                  <div class="col-md-12 common-table-style">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Module</th>
                          <th *ngFor="let permission of permissions">
                            {{ permission.name }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngFor="let module of modules">
                          <ng-container *ngIf="selectedModule == module.id">
                            <tr *ngFor="let submodule of module.subModuleDTOs">
                              <td>{{ submodule.name }}</td>
                              <td *ngFor="let permission of submodule.permissionDTOs">
                                <mat-checkbox color="primary"
                                  [formControlName]="'permissionValue-' + module.id + '-' + submodule.id + '-' + permission.id"
                                  (change)="toggle(permission.id, submodule.id, module.id)"
                                  [disabled]="isPermissionDisabled(module.id, submodule.id, permission.id)"></mat-checkbox>
                              </td>
                            </tr>
                          </ng-container>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-md-12 d-flex p-0 justify-content-end">
                  <button
                    color="warn"
                    class="outlined-btn"
                    mat-raised-button
                    (click)="cancel()"
                  >
                    Cancel
                  </button>
                  <button
                    color="accent"
                    mat-raised-button
                    class="ml-3"
                    [disabled]="!roleForm.valid"
                    (click)="next()"
                  >
                    Next
                  </button>
                </div>
              </form>
            </ng-template>
          </mat-card-content>
        </mat-card>
      </div> -->
<!-- </div>
  </div>
</div> -->
